module.exports = __webpack_public_path__ + "img/empty-cart.c6f057de.svg";